/**
 * 处理图片路径，无域名则拼接当前域名/配置域名
 * @param {string} imgSrc - 图片原始路径
 * @returns {string} 处理后的完整图片路径
 */
export function formatImageSrc(imgSrc) {
    if (!imgSrc || typeof imgSrc !== 'string') {
      return ''
    }
  
    const hasDomainReg = /^https?:\/\//i
    if (hasDomainReg.test(imgSrc)) {
      return imgSrc
    }
  
    // 动态获取当前域名（协议 + 域名+端口）
    let currentDomain = ''
    if (typeof window !== 'undefined') {
      currentDomain = window.location.protocol + '//' + window.location.host
    }
    // 优先使用环境变量配置的域名，无则使用当前域名
    const API_DOMAIN = process.env.VUE_APP_API_DOMAIN || currentDomain
    const cleanImgSrc = imgSrc.startsWith('/') ? imgSrc : `/${imgSrc}`
    const cleanDomain = API_DOMAIN.endsWith('/') ? API_DOMAIN.slice(0, -1) : API_DOMAIN
  
    return `${cleanDomain}${cleanImgSrc}`
}